<template>
  <v-tooltip
    bottom
    color="grey lighten-2"
    v-model="showErrorMessage"
    v-bind="{ disabled: !showErrorMessage }"
  >
    <v-btn
      class="mx-0"
      slot="activator"
      :class="isFavorited ? 'red--text' : ''"
      :style="{ 'text-transform': 'none' }"
      round
      @click="callAddGood"
      small
      data-favorite-button
    >
      <v-icon small class="pr-1">fa fa-heart</v-icon>
      {{ locale === "ja-jp" ? lang.favorite_button_text : ""
      }}{{ this.isDummy ? "***" : this.displayFavoriteCountStr }}
    </v-btn>
    <span class="black--text">{{ this.errorMessage }}</span>
  </v-tooltip>
</template>

<script>
import qs from "qs";

export default {
  name: "vc-share-comic-favorite-button",
  data: () => ({
    isFavorited: false,
    displayFavoriteCount: 0,
    displayFavoriteCountStr: "",
    errorMessage: "",
    showErrorMessage: false
  }),
  props: {
    favoriteCount: {
      type: Number,
      default: 0
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isDummy: {
      type: Boolean,
      default: false
    },
    identificationCode: {
      type: String,
      default: ""
    },
    identificationCodeHash: {
      type: String,
      default: ""
    },
    isOwnContents: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: "ja-jp"
    },
    lang: {
      type: Object,
      default: () => {
        return {
          favorite_button_text: "いいね！",
          failed_contents_register: "「いいね！」に失敗しました",
          can_not_add_like_own_post: "自分の投稿には「いいね！」できません。"
        };
      }
    },
    addGood: {
      type: Function,
      default: () => {}
    }
  },
  mounted: function() {
    this.displayFavoriteCount = this.favoriteCount;
    const params = qs.parse(window.location.search.replace("?", ""));
    if (params["scrollto"] === "fav") {
      this.$vuetify.goTo("[data-favorite-button]", { offset: -70 });
      setTimeout(() => {
        this.callAddGood();
      }, 1000);
    }
    this.displayFavoriteCountStr = parseInt(
      this.displayFavoriteCount
    ).toLocaleString(this.locale);
  },
  methods: {
    callAddGood: function() {
      if (this.isDummy) {
        return;
      }

      if (this.isFavorited) {
        return;
      }

      if (this.isOwnContents) {
        this.showErrorMessage = true;
        this.errorMessage = this.lang.can_not_add_like_own_post;
        setTimeout(() => {
          this.showErrorMessage = false;
        }, 10000);
        return;
      }

      this.isFavorited = true;
      this.displayFavoriteCount += 1;
      this.displayFavoriteCountStr = parseInt(
        this.displayFavoriteCount
      ).toLocaleString(this.locale);

      let requestData = {
        identificationCode: this.identificationCode,
        identificationCodeHash: this.identificationCodeHash
      };

      this.addGood(requestData).then(value => {
        if (value === 0) {
          this.errorMessage = "";
          this.showErrorMessage = false;
          return true;
        }

        if (value.code === "OWN_POST") {
          this.displayFavoriteCountStr = parseInt(
            this.displayFavoriteCount
          ).toLocaleString(this.locale);
          this.errorMessage = this.lang.can_not_add_like_own_post;
        } else {
          this.errorMessage = this.lang.failed_contents_register;
        }

        this.isFavorited = false;
        this.displayFavoriteCount -= 1;
        this.displayFavoriteCountStr = parseInt(
          this.displayFavoriteCount
        ).toLocaleString(this.locale);
        this.showErrorMessage = true;

        setTimeout(() => {
          this.showErrorMessage = false;
        }, 10000);
      });
    }
  }
};
</script>
